import { render, staticRenderFns } from "./SourcesBrowse.vue?vue&type=template&id=401a4b60&scoped=true"
import script from "./SourcesBrowse.vue?vue&type=script&lang=js"
export * from "./SourcesBrowse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401a4b60",
  null
  
)

export default component.exports